import React from "react";
import Modal from "../ModalTemplate";
import Button from "../Button";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import { finishFindGame, getObjectArray } from "../FindGame/index";
import { parseCMSBold } from "../../Helpers";
import { useQueryClient } from "@tanstack/react-query";
import DOMPurify from "dompurify";

export default NiceModal.create(() => {
  const modal = useModal();
  const foundObject = getObjectArray();
  const lastObject = foundObject.length >= 5;
  const queryClient = useQueryClient();

  const closePopup = () => {
    modal.args?.componentSetOpen();
    modal.hide();
  };

  const closeLastModal = () => {
    finishFindGame(queryClient);
  };

  const CancelGame = async () => {
    window.sessionStorage.removeItem("showGame");
    window.dispatchEvent(new Event("storage"));
    modal.hide();
  };

  const cancel = modal.args?.cancel;
  const image = modal.args?.innerImage;
  const copy = modal.args.copy;

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
        if (!cancel) {
          closePopup();
        }
        if (lastObject) {
          closeLastModal();
        }
      }}
      onAfterClose={() => modal.remove()}
      innerClass={`${lastObject ? "lastObject" : ""} ${
        cancel ? "cancel" : ""
      } object-modal`}
    >
      <div className="content-wrapper">
        {
          <>
            {cancel ? (
              <>
                <h4 className="cancel-title">Willst du das Spiel beenden?</h4>{" "}
                <p className="cancel-text">
                  Du erhältst Punkte, wenn du alle 5 spinne findest
                </p>
              </>
            ) : (
              <>
                <div className="text-wrapper">
                  <p className="counter">{foundObject.length}/5</p>
                  <p
                    className="text"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parseCMSBold(copy))}}
                  ></p>
                  <img src={image} className="svgIcon" />
                </div>
              </>
            )}
          </>
        }
        <div className="buttons-wrapper">
          {cancel ? (
            <>
              <Button
                reverse
                btnClass="outline yellow"
                action={(e) => {
                  CancelGame();
                  modal.hide();
                }}
              >
                Beenden
              </Button>
              <Button
                btnClass="yellow"
                action={(e) => {
                  modal.hide();
                }}
              >
                Ich suche weiter
              </Button>
            </>
          ) : (
            <Button
              btnClass="yellow"
              action={(e) => {
                modal.hide();
                if (!cancel) {
                  closePopup();
                }
                if (lastObject) {
                  closeLastModal();
                }
              }}
            >
              OK!
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
});
